<template>
  <simplebar class="chat__messages">
    <transition-group
      tag="div"
      class="layout column ma-0 px-2"
      name="fade-transition"
      appear
    >
      <div
        key="chat__messages_empty"
        class="chat__text chat__messages_empty"
        v-if="!history.length"
      >
        История сообщений остутствует
      </div>
      <template v-else>
        <ChatMessage
          v-for="(msg, i) in history"
          :key="`chat-message-${i}-${msg.sender.id}`"
          :sender="msg.sender"
          :text="msg.body"
          :time="msg.time"
          :attachment="msg.attachment"
          :class="getMessageTeamColor(msg.sender)"
        />
      </template>
    </transition-group>
  </simplebar>
</template>

<script>
import { mapGetters } from "vuex";
import Simplebar from "simplebar-vue";
import ChatMessage from "./ChatMessage";

export default {
  components: { ChatMessage, Simplebar },
  props: {
    player1: {
      type: Object,
      default: () => null
    },
    player2: {
      type: Object,
      default: () => null
    },
    history: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters("auth", ["user"]),

    playersIDs() {
      return [this.player1, this.player2].map(o => o && +o.id);
    }
  },

  methods: {
    getMessageTeamColor(sender) {
      if (!sender) return {};

      return {
        message_red: this.player1 && this.player1.id === sender.id,
        message_blue: this.player2 && this.player2.id === sender.id,
        message_me: this.user && this.user.id === sender.id,
        message_user: this.user && sender.id && this.user.id !== sender.id,
        message_system: !sender.id,
        message_referee:
          !this.playersIDs.includes(sender.id) && !!sender.referee
      };
    }
  }
};
</script>
